import MarketplaceProductPage from './MarketplaceProductPage'

export default MarketplaceProductPage
